import { render } from "./VoiceCallSpinner.vue?vue&type=template&id=b104c844&scoped=true"
import script from "./VoiceCallSpinner.vue?vue&type=script&lang=js"
export * from "./VoiceCallSpinner.vue?vue&type=script&lang=js"

import "./VoiceCallSpinner.vue?vue&type=style&index=0&id=b104c844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b104c844"]])

export default __exports__